import { getFullName, getEmail } from './responderGetters';
export const responderToOption = responder => ({
  text: getFullName(responder) || getEmail(responder),
  value: responder.userId,
  disabled: !responder.assignable,
  responder
});